module.exports = __webpack_public_path__ + "img/ap-concept.6005a36c.jpg";